/**
 * AdminDashboardCards — 3 top-level cards on the admin main page.
 * Each opens a sub-page via the corresponding handler in Admin.jsx.
 */
import { PillBottle, Cpu, ShieldCheck } from "lucide-react";

const CARDS = [
  {
    key: "drugs", handler: "onOpenDrugs",
    Icon: PillBottle, tone: "border-slate-200 hover:border-slate-400 bg-white",
    title: "إدارة الأدوية",
    desc: "قائمة الأدوية · إضافة دواء · إحصائيات البحث",
    testid: "card-drugs",
  },
  {
    key: "ai", handler: "onOpenAI",
    Icon: Cpu, tone: "border-blue-200 hover:border-blue-300 bg-blue-50",
    title: "نماذج الذكاء الاصطناعي",
    desc: "Gemini · DeepSeek — الاستهلاك والإحصائيات والإعدادات",
    testid: "card-ai",
  },
  {
    key: "account", handler: "onOpenAccount",
    Icon: ShieldCheck, tone: "border-emerald-200 hover:border-emerald-300 bg-emerald-50",
    title: "الحساب والأمان",
    desc: "كلمة المرور · تسجيل الخروج · إدارة المستخدمين",
    testid: "card-account",
  },
];

export default function AdminDashboardCards({ handlers }) {
  return (
    <div data-testid="admin-dashboard-cards" className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
      {CARDS.map((c) => {
        const Icon = c.Icon;
        return (
          <button key={c.key} type="button" data-testid={c.testid}
            onClick={() => handlers?.[c.handler]?.()}
            className={`text-right flex flex-col gap-3 border-2 rounded-2xl p-6 min-h-[140px] transition-colors cursor-pointer ${c.tone}`}>
            <Icon className="w-8 h-8 text-slate-700" />
            <span className="font-bold text-xl text-slate-900">{c.title}</span>
            <span className="text-sm text-slate-600 leading-relaxed">{c.desc}</span>
          </button>
        );
      })}
    </div>
  );
}
